import React, { useEffect, useState } from "react";
import { Badge, Button, Col, Dropdown, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import ImageViewer from "../../../components/ImageViewer";
import ActionButton from "../../../components/ActionButton";
import "simplebar-react/dist/simplebar.min.css";
import { getAccountTransactionHistory, getUserFinancialSummary, generateUserReport, generateBankReport, generateSupplierReport, generateUserExcelReport, generateBankExcelReport, generateSupplierExcelReport, generateUserItemwiseReport, generateUserItemwiseExcelReport, getSupplierTransactions, downloadSupplierItemsPdf, downloadSupplierItemsExcel } from "../../../services/contractorApi";
import ReactPagination from "../../../components/ReactPagination";
import { BsDashLg, BsPlusLg, BsFileEarmarkPdfFill, BsPencilSquare } from "react-icons/bs";
import { FaFileExcel } from "react-icons/fa";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import DatePickercomp from "../../../components/DatePicker";
import FormLabelText from "../../../components/FormLabelText";
import { useParams, useSearchParams } from "react-router-dom";
import { getPreviousFundRequestById } from "../../../services/contractorApi";
import { getAdminAllHREmployees, downloadUserLoanStatement } from "../../../services/authapi";
import { AccountDetailCard } from "../../../components/ItemDetail";
import { MyInput } from "../../../components/MyInput";
import { toast } from "react-toastify";
import { upperFileName } from "../../../utils/downloadServerFile";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/auth/authSlice";
import { updateUserTransactionDetails, updateBankTransactionDetails } from "../../../services/contractorApi";

// Caret-less dropdown toggle so the download icon renders clean (no button
// chrome / caret). Used for the User-screen report-type menus.
const IconToggle = React.forwardRef(({ children, onClick, disabled, title }, ref) => (
  <button
    ref={ref}
    type="button"
    title={title}
    disabled={disabled}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{
      background: "none",
      border: "none",
      cursor: disabled ? "not-allowed" : "pointer",
      padding: 0,
      lineHeight: 0,
    }}
  >
    {children}
  </button>
));

export const ViewTransaction = ({ edit }) => {
  // console.log("edit", edit);
  const [userSummary, setUserSummary] = useState(null);
  const [transaction, setTransaction] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageDetail, setPageDetail] = useState({});
  const [collapsedRows, setCollapsedRows] = useState([]);
  const [filterBy, setFilterby] = useState("last12Months");
  const [transactionType, setTransactionType] = useState(null);
  const [complaintOptions, setComplaintOptions] = useState([]);
const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [fromDate, setFromDate] = useState(() => {
    // Prefer the date carried from the outer list (Supplier Reports tab) so the
    // view opens on the same period the user was looking at.
    const qp = new URLSearchParams(window.location.search).get("fromDate");
    if (qp) return qp;
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const year = firstDay.getFullYear();
    const month = String(firstDay.getMonth() + 1).padStart(2, "0");
    const day = String(firstDay.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  });

  const [toDate, setToDate] = useState(() => {
    const qp = new URLSearchParams(window.location.search).get("toDate");
    if (qp) return qp;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);

  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const isuser = searchParams.get("isuser") === "true";
  const iscreditor = searchParams.get("iscreditor") === "true";

  const [userOptions, setUserOptions] = useState([]);
const [selectedUser, setSelectedUser] = useState(null);
  const [previousFundAmount, setPreviousFundAmount] = useState(0);
  const [previousFundAmountData, setPreviousFundAmountData] = useState([]);
  const [summary, setSummary] = useState(0);
  const [total, setTotal] = useState(0);
  const { id } = useParams();

  const isSupplierContext = typeof window !== "undefined"
    && window.location.pathname.includes("/Suppliers/");

  // ── Edit an entry's Narration / Transaction ID ──────────────────────────
  // User statement: the Edit right on Bank Management → User Accounts; bank
  // statement (2026-11-03): the Edit right on Bank Management → Bank Accounts —
  // the same nodes the server checks. Their path (/bank?tab=0) is shared, so
  // the title picks the node.
  const { userPermission } = useSelector(selectUser);
  const canEditEntries = (() => {
    const titleRe = isuser ? /user accounts/i : /bank accounts/i;
    const find = (list) => {
      for (const n of list || []) {
        if (n?.path === "/bank?tab=0" && titleRe.test(n?.title || "")) return n;
        const hit = find(n?.submodules) || find(n?.modulesOfSubModule) || find(n?.subTabs);
        if (hit) return hit;
      }
      return null;
    };
    const node = find(userPermission);
    return Number(node?.update ?? node?.updated ?? 0) > 0;
  })();
  // the bank statement's rows (not the supplier view, which reads another table)
  const isBankStatement = !isuser && !isSupplierContext;
  const showEntryEdit = canEditEntries && (isuser || isBankStatement);
  const [entryEdit, setEntryEdit] = useState(null); // { id, description, transaction_id }
  const [entrySaving, setEntrySaving] = useState(false);
  const saveEntryEdit = async () => {
    if (!String(entryEdit?.description || "").trim()) {
      toast.error(isuser ? t("Narration is required") : t("Remark is required"));
      return;
    }
    setEntrySaving(true);
    const res = isuser ? await updateUserTransactionDetails(entryEdit) : await updateBankTransactionDetails(entryEdit);
    setEntrySaving(false);
    if (res?.status) {
      toast.success(res.message || t("Entry updated"));
      setEntryEdit(null);
      fetchSingleData();
    } else {
      toast.error(res?.message || t("Could not update the entry"));
    }
  };

  const fetchSingleData = async () => {
    let res;
    if (isSupplierContext) {
      // Supplier path uses a separate endpoint that pulls from
      // stock_requests + supplier_transactions instead of account_transactions.
      const supplierId = edit?.id || id;
      res = await getSupplierTransactions(
        supplierId,
        pageSize,
        pageNo,
        fromDate,
        toDate,
        transactionType
      );
    } else {
      res = await getAccountTransactionHistory(
        edit?.account_id,
        filterBy,
        pageSize,
        pageNo,
        fromDate,
        toDate,
        isuser,
        transactionType,
        selectedComplaint?.value,
        selectedUser?.value
      );
    }

    console.log("res",res)

    if (res.status) {
      const arr = res.data;

      // set only transaction rows (remove totals obj)
      const txData = arr.filter((item) => item.category_type);
     console .log("txDate",txData)
      setTransaction(txData);
      const users = txData
  .flatMap((item) => [
    (item.from_user_name || item.from_bank_account_holder_name) && {
      label: item.from_user_name || item.from_bank_account_holder_name,
      value: item.from_user_name || item.from_bank_account_holder_name
    },

    (item.to_bank_account_name || item.to_user_account_name) && {
      label: item.to_bank_account_name || item.to_user_account_name,
      value: item.to_bank_account_name || item.to_user_account_name
    }
  ])
  .filter(Boolean);

// remove duplicates
const uniqueUsers = [
  ...new Map(users.map((item) => [item.label, item])).values()
];

setUserOptions(uniqueUsers);
      
      // Complaint dropdown options
const complaints = txData
  .map((item) => ({
    label: item.complaint_unique_id,
    value: item.complaint_id
  }))
  .filter((item) => item.value);
  console.log("txData", txData);

// duplicate remove
const uniqueComplaints = [
  ...new Map(complaints.map((item) => [item.value, item])).values()
];

setComplaintOptions(uniqueComplaints);
      setSummary(res.summary || {}); // store full summary from API
      setPageDetail(res.pageDetails);
    }
    else {
      setTransaction([]);
      setSummary({});
    }
  };

  const fetchFromUserFinancialSummary = async (userId) => {
    if (!userId) {
      setUserSummary(null);
      return;
    }

    const res = await getUserFinancialSummary(userId, {
      fromDate,
      toDate,
    });

    if (res.status) {
      setUserSummary(res.data);
    } else {
      setUserSummary(null);
    }
  };

  const handlePageSizeChange = (selectedOption) => {
    setPageSize(selectedOption.value);
  };

  const toggleRow = (index) => {
    setCollapsedRows((prev) => {
      const isCollapsed = prev.includes(index);
      if (isCollapsed) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };
  const getPreviousFundRequestDetails = async (id, requestId) => {
    const res = await getPreviousFundRequestById(id, requestId);
    if (res.status) {
      setPreviousFundAmount(res?.finalBalance);
      setPreviousFundAmountData(res?.data);
    } else {
      setPreviousFundAmount(0);
    }
  };

  // const handleDownloadReport = async () => {
  //   const formatDate = (dateStr) => {
  //     if (!dateStr) return "";
  //     const [year, month, day] = dateStr.split("-");
  //     return `${day}-${month}-${year}`;
  //   };
  //   setIsPdfLoading(true);
  //   try {
  //     const userId = edit?.id || id;
  //     const res = await generateUserReport(userId, formatDate(fromDate), formatDate(toDate));
  //     if (res?.data) {
  //       const contentDisposition = res.headers?.["content-disposition"] || "";
  //       const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
  //       const filename = filenameMatch ? filenameMatch[1] : "bank-report.pdf";

  //       const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", filename);
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //     }
  //   } finally {
  //     setIsPdfLoading(false);
  //   }
  // };

  const handleDownloadReport = async () => {
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  setIsPdfLoading(true);

  try {
    let res;

    if (isuser) {
      // ✅ USER SCREEN
      const userId = edit?.id || id;

      res = await generateUserReport(
        userId,
        formatDate(fromDate),
        formatDate(toDate)
      );

      if (res?.data) {
        const contentDisposition = res.headers?.["content-disposition"] || "";
        const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
        const filename = filenameMatch ? filenameMatch[1] : "report.pdf";
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }

    } else if (window.location.pathname.includes("/Suppliers/")) {
      // ✅ SUPPLIER SCREEN
      const supplierId = edit?.id || id;

      res = await generateSupplierReport(
        supplierId,
        formatDate(fromDate),
        formatDate(toDate)
      );

      if (res?.data) {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "supplier_report.pdf";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
          if (match && match[1]) filename = match[1].trim();
        }
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }

    } else {
      // ✅ BANK ACCOUNT SCREEN
      const accountId = edit?.account_id || id;

      res = await generateBankReport(
        accountId,
        formatDate(fromDate),
        formatDate(toDate)
      );

      if (res?.data) {
        const contentDisposition = res.headers?.["content-disposition"] || "";
        const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
        const filename = filenameMatch ? filenameMatch[1] : "report.pdf";
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    }

    if (!res?.data) {
      toast.error(res?.message || "Failed to download PDF report. Please try again.");
    }

  } finally {
    setIsPdfLoading(false);
  }
};

  const handleDownloadExcelReport = async () => {
    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      const [year, month, day] = dateStr.split("-");
      return `${day}-${month}-${year}`;
    };

    setIsExcelLoading(true);
    try {
      let res;
      if (isuser) {
        const userId = edit?.id || id;
        res = await generateUserExcelReport(userId, formatDate(fromDate), formatDate(toDate));
      } else if (window.location.pathname.includes("/Suppliers/")) {
        const supplierId = edit?.id || id;
        res = await generateSupplierExcelReport(supplierId, formatDate(fromDate), formatDate(toDate));
      } else {
        const accountId = edit?.account_id || id;
        res = await generateBankExcelReport(accountId, formatDate(fromDate), formatDate(toDate));
      }

      if (res?.data) {
        const contentDisposition = res.headers?.["content-disposition"] || "";
        const filename = contentDisposition.split("filename=")[1]?.replace(/"/g, "")?.trim() || "report.xlsx";
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = upperFileName(filename);
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
      if (!res?.data) {
        toast.error(res?.message || "Failed to download Excel report. Please try again.");
      }
    } finally {
      setIsExcelLoading(false);
    }
  };

  // ── Item-wise report (User screen only) ──────────────────────────────
  // Reformats YYYY-MM-DD → DD-MM-YYYY (same as the summary handlers) and
  // triggers a Blob download from the new item-wise endpoints. The summary
  // report (generateUserReport / generateUserExcelReport) is left untouched.
  const formatReportDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const triggerBlobDownload = async (res, fallbackName, mimeType) => {
    // Service returned an error object (network/500/etc.) instead of a blob.
    if (!res?.data) {
      toast.error(res?.message || "Download failed. Please try again.");
      return;
    }
    // responseType was "blob" but the server sent a JSON error body — decode
    // it so the real reason is shown instead of downloading a broken file.
    const blob = res.data;
    if (blob && typeof blob.type === "string" && blob.type.includes("application/json")) {
      try {
        const j = JSON.parse(await blob.text());
        toast.error(j?.message || "Download failed. Please try again.");
        return;
      } catch (_) {
        /* fall through and attempt the download anyway */
      }
    }
    const contentDisposition = res.headers?.["content-disposition"] || "";
    const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
    // Download names use hyphens, never underscores — same rule the backend applies.
    const filename = (match ? match[1].trim() : fallbackName).replace(/[_\s]+/g, "-");
    const url = window.URL.createObjectURL(
      mimeType ? new Blob([res.data], { type: mimeType }) : new Blob([res.data]),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadItemwisePdf = async () => {
    setIsPdfLoading(true);
    try {
      const entityId = edit?.id || id;
      // Supplier context uses the supplier-items report; user context uses the
      // user item-wise report.
      const res = isSupplierContext
        ? await downloadSupplierItemsPdf(
            entityId,
            formatReportDate(fromDate),
            formatReportDate(toDate),
          )
        : await generateUserItemwiseReport(
            entityId,
            formatReportDate(fromDate),
            formatReportDate(toDate),
          );
      triggerBlobDownload(res, "itemwise_report.pdf", "application/pdf");
    } finally {
      setIsPdfLoading(false);
    }
  };

  const handleDownloadItemwiseExcel = async () => {
    setIsExcelLoading(true);
    try {
      const entityId = edit?.id || id;
      const res = isSupplierContext
        ? await downloadSupplierItemsExcel(
            entityId,
            formatReportDate(fromDate),
            formatReportDate(toDate),
          )
        : await generateUserItemwiseExcelReport(
            entityId,
            formatReportDate(fromDate),
            formatReportDate(toDate),
          );
      triggerBlobDownload(
        res,
        "itemwise_report.xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      );
    } finally {
      setIsExcelLoading(false);
    }
  };

  // ── Loan / Advance statement (User screen only) ──────────────────────
  // This person's loans, or advances, for the dates picked on this screen:
  // given, due and recovered in the period, and outstanding at its end.
  // `kind` is "loan" or "advance" — two separate reports.
  const handleDownloadLoanStatement = async (format, kind) => {
    const setBusy = format === "excel" ? setIsExcelLoading : setIsPdfLoading;
    setBusy(true);
    try {
      const res = await downloadUserLoanStatement({
        user_id: edit?.id || id,
        from_date: fromDate,
        to_date: toDate,
        format,
        kind,
      });
      triggerBlobDownload(
        res,
        `${kind}_statement.${format === "excel" ? "xlsx" : "pdf"}`,
        format === "excel"
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "application/pdf",
      );
    } finally {
      setBusy(false);
    }
  };

  const Transaction_Type = [
    { value: "C", label: "Credit" },
    { value: "D", label: "Debit" },
  ];

  // useEffect(() => {
  //   if (edit?.account_id) {
  //     console.log(edit, "edit");
  //     fetchSingleData();
  //     getPreviousFundRequestDetails(edit?.id, "null");
  //   }
  // }, [edit, pageNo, filterBy, pageSize, fromDate, toDate, isuser, transactionType]);

  useEffect(() => {
    if (isSupplierContext) {
      // Supplier path: account_id doesn't exist; fetcher resolves supplier id internally.
      fetchSingleData();
    } else if (edit?.account_id) {
      fetchSingleData();
      getPreviousFundRequestDetails(edit?.id, "null");
    }

    if (id) {
      fetchFromUserFinancialSummary(id);
    }

  }, [edit, pageNo, filterBy, pageSize, fromDate, toDate, isuser, transactionType,selectedComplaint,selectedUser, id]);

  const filteredTransactions = transaction.filter((item) => {

  const complaintMatch = selectedComplaint
    ? item.complaint_id === selectedComplaint.value
    : true;

  const userMatch = selectedUser
  ? item.from_user_name === selectedUser.value ||
    item.from_bank_account_holder_name === selectedUser.value ||
    item.to_bank_account_name === selectedUser.value ||
    item.to_user_account_name === selectedUser.value
  : true;

  return complaintMatch && userMatch;

});
  return (
    <Row className="g-3">
      <Col md={12}>
        {/* <strong className="text-secondary">{t("Account Details")} </strong> */}
        <div className="mt-2">
          {/* <table className="table-sm table">
              <tbody>
                <tr>
                  <th>{t("Account Holder")}:</th>
                  <td>{edit?.accounts?.[0].account_holder_name ?? "--"}</td>
                </tr>
                <tr>
                  <th>{t("Created By")}:</th>
                  <td>{edit?.accounts?.[0].user_name ?? "--"}</td>
                </tr>
                <tr>
                  <th className="align-middle">{t("Bank Name")} :</th>
                  <td>
                    <ImageViewer
                      src={
                        edit?.bank_logo
                          ? `${process.env.REACT_APP_API_URL}${edit?.bank_logo}`
                          : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                      }
                    >
                      <img
                        width={35}
                        height={35}
                        className="my-bg object-fit p-1 rounded-circle"
                        src={
                          edit?.bank_logo
                            ? `${process.env.REACT_APP_API_URL}${edit?.bank_logo}`
                            : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                        }
                      />{" "}
                    </ImageViewer>
                    {edit?.bank_name}
                  </td>
                </tr>

                <tr>
                  <th>{t("Account Number")}:</th>
                  <td>{edit?.accounts?.[0].account_number}</td>
                </tr>

                <tr>
                  <th>{t("Ifsc Code")}:</th>
                  <td>{edit?.accounts?.[0].ifsc_code}</td>
                </tr>

                <tr>
                  <th>{t("Branch")}:</th>
                  <td>{edit?.accounts?.[0]?.branch}</td>
                </tr>
                <tr>
                  <th>{t("Account Type")}:</th>
                  <td>{edit?.accounts?.[0]?.account_type}</td>
                </tr>
                <tr>
                  <th>{t("Account Status")}:</th>
                  <td>
                    <Badge
                      bg="secondary"
                      className="fw-normal"
                      style={{ fontSize: 11 }}
                    >
                      {edit?.accounts?.[0]?.is_default
                        ? "Active"
                        : "Not Active"}
                    </Badge>
                  </td>
                </tr>

                <tr>
                  <th className="align-middle">{t("Action")} :</th>
                  <td>
                    <ActionButton
                      className="justify-content-start"
                      hideDelete={"d-none"}
                      hideEye={"d-none"}
                      editlink={`/account-management/create-account-management/${edit?.account_id}`}
                    />
                  </td>
                </tr>
              </tbody>
            </table> */}
          <Row>
            {/* Left Panel – User Details */}
                      <Col md={6}>
              <div className="p-20 shadow rounded h-100">
                <strong className="text-secondary">{t("User Details")}</strong>
                <div className="mt-2">
                  <table className="table-sm table">
                    <tbody>
                      <tr>
                        <th>{t("Holder Name")} :</th>
                        <td>{isSupplierContext
                          ? (edit?.supplier_name || edit?.account_holder_name || "--")
                          : (edit?.accounts?.[0]?.account_holder_name ?? edit?.account_holder_name ?? "--")}</td>
                      </tr>
                      <tr>
                        <th>{t("Account Number")} :</th>
                        <td>{edit?.accounts?.[0]?.account_number ?? edit?.account_number ?? "--"}</td>
                      </tr>

                      {isuser && !iscreditor && (
                        <tr>
                          <th>{t("Fund Limit")} :</th>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            ₹{" "}
                            {Number(
                              previousFundAmountData?.[0]?.fund_limit || 0
                            ).toFixed(2)}
                          </td>
                        </tr>
                      )}

                      {!isuser && (
                        <tr>
                          <th>{t("Account Type")} :</th>
                          <td>{edit?.accounts?.[0]?.account_type ?? edit?.account_type ?? "--"}</td>
                        </tr>
                      )}

                      <tr>
                        <th>{t("Opening Balance")} :</th>
                        <td style={{ color: "green", fontWeight: "600" }}>
                          ₹{" "}
                          {Number(edit?.accounts?.[0]?.opening_balance ?? edit?.opening_balance ?? 0).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Current Balance")} :</th>
                        <td style={{ color: "green", fontWeight: "600" }}>
                          ₹{" "}
                          {Number(edit?.accounts?.[0]?.closing_balance ?? edit?.closing_balance ?? 0).toFixed(2)}
                        </td>
                      </tr>

                      {isuser && !iscreditor && (
                        <>
                          <tr>
                            <th>{t("Amount Punched")} :</th>
                            <td style={{ color: "green", fontWeight: "600" }}>
                              {previousFundAmountData != null
                                ? `₹ ${Number(
                                  previousFundAmountData[0]
                                    ?.total_amount_punched
                                ).toFixed(2)}`
                                : "-"}
                            </td>
                          </tr>
                          {/* <tr>
                            <th>{t("Amount Transferred")} :</th>
                            <td>
                              {previousFundAmountData != null
                                ? `₹${Number(previousFundAmountData[0]?.total_transfer_amount).toFixed(2)}`
                                : "-"}
                            </td>
                          </tr> */}
                        </>
                      )}

                      <tr>
                        <th>{t("Status")} :</th>
                        <td>
                          <td>
                            <Badge
                              bg={(edit?.accounts?.[0]?.is_default ?? edit?.status) === 1 ? "success" : "secondary"}
                              className="fw-normal"
                              style={{ fontSize: 11 }}
                            >
                              {(edit?.accounts?.[0]?.is_default ?? edit?.status) === 1 ? "Active" : "Not Active"}
                            </Badge>
                          </td>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>


            {/* Right Panel – Bank Details */}
            <Col md={6}>
              <div className="p-20 shadow rounded h-100">
                <div className="d-flex justify-content-between align-items-center">
                  <strong className="text-secondary">{t("Bank Details")}</strong>
                  <div className="d-flex align-items-center gap-2">
                    {isuser || isSupplierContext ? (
                      <>
                        {/* User + Supplier screens: each download offers Summary
                            + Item-wise report types via a dropdown on the icon. */}
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            as={IconToggle}
                            disabled={isExcelLoading}
                            title="Download Excel Report"
                          >
                            {isExcelLoading ? (
                              <Spinner animation="grow" size="sm" variant="success" />
                            ) : (
                              <FaFileExcel size={24} color="#1d6f42" />
                            )}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={handleDownloadExcelReport}>
                              {t("Summary Report")}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={handleDownloadItemwiseExcel}>
                              {t("Item-wise Report")}
                            </Dropdown.Item>
                            {isuser && !iscreditor && !isSupplierContext && (
                              <>
                                <Dropdown.Item onClick={() => handleDownloadLoanStatement("excel", "loan")}>
                                  {t("Loan Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDownloadLoanStatement("excel", "advance")}>
                                  {t("Advance Report")}
                                </Dropdown.Item>
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            as={IconToggle}
                            disabled={isPdfLoading}
                            title="Download PDF Report"
                          >
                            {isPdfLoading ? (
                              <Spinner animation="grow" size="sm" variant="danger" />
                            ) : (
                              <BsFileEarmarkPdfFill size={24} color="#dc3545" />
                            )}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={handleDownloadReport}>
                              {t("Summary Report")}
                            </Dropdown.Item>
                            <Dropdown.Item onClick={handleDownloadItemwisePdf}>
                              {t("Item-wise Report")}
                            </Dropdown.Item>
                            {isuser && !iscreditor && !isSupplierContext && (
                              <>
                                <Dropdown.Item onClick={() => handleDownloadLoanStatement("pdf", "loan")}>
                                  {t("Loan Report")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDownloadLoanStatement("pdf", "advance")}>
                                  {t("Advance Report")}
                                </Dropdown.Item>
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={handleDownloadExcelReport}
                          disabled={isExcelLoading}
                          title="Download Excel Report"
                          style={{ background: "none", border: "none", cursor: isExcelLoading ? "not-allowed" : "pointer", padding: 0 }}
                        >
                          {isExcelLoading ? (
                            <Spinner animation="grow" size="sm" variant="success" />
                          ) : (
                            <FaFileExcel size={24} color="#1d6f42" />
                          )}
                        </button>
                        <button
                          onClick={handleDownloadReport}
                          disabled={isPdfLoading}
                          title="Download PDF Report"
                          style={{ background: "none", border: "none", cursor: isPdfLoading ? "not-allowed" : "pointer", padding: 0 }}
                        >
                          {isPdfLoading ? (
                            <Spinner animation="grow" size="sm" variant="danger" />
                          ) : (
                            <BsFileEarmarkPdfFill size={24} color="#dc3545" />
                          )}
                        </button>
                      </>
                    )}
                  </div>
                </div>
                <div className="mt-2">
                  <table className="table-sm table">
                    <tbody>
                      <tr>
                        <th className="align-middle">{t("Bank Name")} :</th>
                        <td>
                          <ImageViewer
                            src={
                              edit?.bank_logo
                                ? `${process.env.REACT_APP_API_URL}${edit?.bank_logo}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          >
                            <img
                              width={35}
                              height={35}
                              className="my-bg object-fit p-1 rounded-circle"
                              src={
                                edit?.bank_logo
                                  ? `${process.env.REACT_APP_API_URL}${edit?.bank_logo}`
                                  : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                              }
                            />{" "}
                          </ImageViewer>
                          {/* {edit?.bank_name ?? "--"} */}
                          {userSummary?.bank_name || edit?.bank_name || "--"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("IFSC Code")} :</th>
                        {/* <td>{edit?.ifsc_code ?? "--"}</td> */}
                        <td>{userSummary?.ifsc_code ?? edit?.ifsc_code ?? "--"}</td>
                      </tr>

                      <tr>
                        <th>{t("From Date")} :</th>
                        <td>
                          <td>
                            {fromDate
                              ? new Date(fromDate).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              : "--"}
                          </td>
                        </td>
                      </tr>

                      <tr>
                        <th>{t("To Date")} :</th>
                        <td>
                          {toDate
                            ? new Date(toDate).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            : "--"}
                        </td>
                      </tr>

                      {!isuser && (
                        <tr>
                          <th>{t("Branch")} :</th>
                          <td>{edit?.branch ?? "--"}</td>
                        </tr>
                      )}
                      <tr>
                        <th>{t("Creation Date")} :</th>
                        <td>{edit?.created_at ?? "--"}</td>
                      </tr>

                      {/* <tr>
                          <th>{t("Other Details")} :</th>
                          <td>{edit?.accounts?.[0]?.other_bank_details ?? "--"}</td>
                        </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>

      <Col md={12} className="my-4">
        {/* <span className="d-align d-md-flex d-grid justify-content-end gap-2">
          {t("Filter By")}
          <Select
            menuPortalTarget={document.body}
            placeholder={t("Select Date")}
            defaultValue={{ label: "Last 12 Months", value: "last12Months" }}
            options={[
              { label: "Today", value: "today" },
              { label: "Yesterday", value: "yesterday" },
              { label: "This Week", value: "thisWeek" },
              { label: "Last Week", value: "lastWeek" },
              { label: "This Month", value: "thisMonth" },
              { label: "Last Month", value: "lastMonth" },
              { label: "this Quarter", value: "thisQuarter" },
              { label: "Last Quarter", value: "lastQuarter" },
              { label: "Last 6 Months", value: "last6Months" },
              { label: "Last 12 Months", value: "last12Months" },
            ]}
            // isClearable
            onChange={(e) => {
              setFilterby(e ? e.value : null);
            }}
          />
        </span> */}

        <Col
          md={12}
          className="d-flex justify-content-between my-2 mx-2 align-items-center "
        >
          {/* <strong className="text-secondary  ">
            {t("Account Transaction History")}
          </strong> */}

          <Row className="d-flex justify-content-end align-items-center">

            {!isSupplierContext && (
            <Col>
            <FormLabelText>{t("User")}</FormLabelText>
             <Select
menuPortalTarget={document.body}
placeholder="Select User"
value={selectedUser}
options={userOptions}
isClearable
onChange={(e) => {
  setSelectedUser(e);
  setPageNo(1);
}}
/>
            </Col>
            )}
            {!isSupplierContext && (
            <Col>
  <FormLabelText>{t("Complaint Type")}</FormLabelText>

  <Select
  menuPortalTarget={document.body}
  placeholder={t("Complaint")}
  value={selectedComplaint}
  options={complaintOptions}
  isClearable
  onChange={(e) => {
    setSelectedComplaint(e);
    setPageNo(1); // pagination reset
  }}
/>
</Col>
            )}
            <Col>
              <FormLabelText>{t("Transaction Type")}</FormLabelText>
              <Select
                menuPortalTarget={document.body}
                placeholder={t("Select Type")}
                options={Transaction_Type}
                onChange={(e) => {
                  setTransactionType(e ? e.value : null);
                }}/>
            </Col>

            <Col>
              <FormLabelText>{t("From Date")}</FormLabelText>
              <DatePickercomp
                value={fromDate}
                sendDate={handleDateChange}
                label={t("From Date")}
              />
            </Col>
            <Col>
              <FormLabelText>{t("To Date")}</FormLabelText>
              <DatePickercomp
                value={toDate}
                sendDate={handleToDateChange}
                label={t("To Date")}
              />
            </Col>
          </Row>
        </Col>

        <div className="table-scroll my-3">
          <Table className="text-body bg-new Roles">
            <thead className="text-truncate">
              <tr style={{ minWidth: "120px" }}>
                <th>{t("Date")}</th>
                <th>{t("Transaction From /To")}</th>

                <th>{t("Narration Details")}</th>
                <th>{t("Transfer From")}</th>
                <th>{t("Transfer To")}</th>
                <th>{t("Transaction ID")}</th>
                <th>{t("Status")}</th>

                <th>{t("Withdrawal (Debit)")}</th>
                <th>{t("Deposit (Credit)")}</th>
                <th>{t("Closing Balance")}</th>
                <th>{t("Payment Mode")}</th>
                {showEntryEdit && <th>{t("Action")}</th>}
              </tr>

            </thead>
            <tbody>
              {transaction?.length ? (
                <>
                  {filteredTransactions
  ?.filter((data) => data?.category_type)
  .map((data, id)=> {
                    return (
                      <tr key={id}>
                        {/* Date */}
                        <td style={{ minWidth: "120px" }}>
                          {data?.date
                            ? new Date(data.date).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short", // "short" => Jul, "long" => July
                              year: "numeric",
                            })
                            : "----"}
                        </td>
                        {/* Transfer From */}
                        {/* <td>
                          {(() => {
                            switch (data?.category_type) {
                              case "BB":
                                return "Bank to Bank";
                              case "BU":
                                return "Bank to User";

                              case "BC":
                                return "Bank to Creditor";
                              case "UB":
                                return "User to Bank";
                              case "CB":
                                return "Creditor to Bank";
                              case "DB":
                                return "Cash Deposit to bank";
                              case "WU":
                                return "Withdraw from User";
                              case "DU":
                                return "Deposit to User";
                              case "UU":
                                return "User to User";
                              case "CW":
                                return "Cash Withdrawal from Creditor";
                              case "BW":
                                return "Bank to Cash Withdrawal";
                              case "CR":
                                return "Credit ";
                              case "DC":
                                return "Cash Deposit to Creditor";
                              case "FT":
                                return "Fund Transfer";
                              case "fund":
                                return "Fund Transfer";

                              default:
                                return "";
                            }
                          })()}
                        </td> */}
                        <td>
  {(() => {
    switch (data?.category_type) {

  case "SP":
        return (
          <>
            Stock Punch
            {data?.complaint_unique_id && (
              <div style={{ fontSize: "11px", color: "#0d6efd" }}>
                {data?.complaint_unique_id}
              </div>
            )}
          </>
        );

      case "EP":
        return (
          <>
            Fund Punch
            {data?.complaint_unique_id && (
              <div style={{ fontSize: "11px", color: "#0d6efd" }}>
                {data?.complaint_unique_id}
              </div>
            )}
          </>
        );


  case "ST":
    return "User Stock Transfer";

  case "FE":
    return "User Fund Transfer";

  case "FT":
    return "Fund Transfer";

  case "SUP_BILL":
    return "Supplier Bill";

  case "SUP_PMT":
    return "Supplier Payment";

  // Bank-side rows of the HR payment flows. loan_kind (from the loans row the
  // payment points back at) says WHICH kind — loan or advance.
  case "salary":
    return "Salary Payment";
  case "loan":
    return data?.loan_kind === "advance"
      ? "Advance Payment"
      : data?.loan_kind === "loan"
        ? "Loan Payment"
        : "Loan/Advance Payment";

  // Employee-side rows of the same payments, on the user statement.
  case "SAL":
    return "Salary";
  case "LN":
    return data?.loan_kind === "advance"
      ? "Advance"
      : data?.loan_kind === "loan"
        ? "Loan"
        : "Loan/Advance";

  default:
    return "--";
}
  })()}
</td>

                        {/* Narration Details (old "description") */}
                        <td>{data?.description ?? "----"}</td>

                        {/* Transfer From */}
                        {/* Transfer From (show only when status is debit) */}
                        {/* Transfer From (show only when status is credit) */}
                        {data?.status?.toLowerCase() === "credit" ? (
                          <td style={{ minWidth: "120px" }}>
                            <AccountDetailCard
                              name={
                                data.from_user_name || data.from_bank_account_holder_name
                              }
                              accountNumber={
                                data.from_user_account__number || data.from_bank_account_number
                              }
                              bankName={`${data.from_user_bank_name || data.from_bank_name || data.to_bank_name} | Balance: ₹${data.from_user_updated_balance || data.from_bank_updated_balance || data.to_bank_updated_balance || 0
                                }`}
                            />
                          </td>
                        ) : (
                          <td></td>  // blank for layout
                        )}

                        {/* If status is credit, render empty td to maintain table layout */}



                        {/* Transfer To */}
                        {/* Transfer To (always show for both debit and credit) */}
                        {/* Transfer To (show only when status is debit) */}
                        {data?.status?.toLowerCase() === "debit" ? (
                          <td style={{ minWidth: "150px" }}>
                            <AccountDetailCard
                              name={
                                data.to_bank_account_name || data.to_user_account_name
                              }
                              accountNumber={
                                data.to_bank_account_number || data.to_user_account_number
                              }
                              bankName={`${data.transfer_to_bank_name || data.to_user_name || data.to_user_bank_name || data.to_bank_name
                                } | Balance: ₹${data.to_bank_updated_balance || data.to_user_updated_balance || 0
                                }`}
                            />
                          </td>
                        ) : (
                          <td></td>
                        )}



                        {/* Cheque/Ref.No (old "status" use karlo yahan) */}
                        <td>{data?.transaction_id ?? "----"}</td>
                        <td>{data?.status ?? "----"}</td>

                        {/* Withdrawal (if transaction negative) */}
                        {/* Withdrawal (Debit) */}
                        <td className="text-danger fw-bold">
                          {data?.status?.toLowerCase() === "debit"
                            ? `-₹${Number(data?.transaction_amount).toFixed(2)}`
                            : "-"}
                        </td>

                        {/* Credit */}
                        <td className="text-success fw-bold">
                          {data?.status?.toLowerCase() === "credit"
                            ? `+₹${Number(data?.transaction_amount).toFixed(2)}`
                            : "-"}
                        </td>

                        {/* Closing Balance */}
                        <td className="text-success fw-bold">
                          {data?.updated_balance_selec_ac != null
                            ? `₹${Number(data?.updated_balance_selec_ac).toFixed(2)}`
                            : "----"}
                        </td>
                        <td>{data?.payment_mode_name ?? "----"}</td>
                        {showEntryEdit && (
                          <td className="text-center">
                            {(isuser ? data?.txn_row_id : data?.bank_txn_row_id) ? (
                              <BsPencilSquare
                                role="button"
                                title={isuser ? t("Edit Narration / Transaction ID") : t("Edit Remark / Transaction ID")}
                                className="text-danger"
                                onClick={() =>
                                  setEntryEdit({
                                    id: isuser ? data.txn_row_id : data.bank_txn_row_id,
                                    description: data?.description || "",
                                    transaction_id: data?.transaction_id || "",
                                  })
                                }
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                  <tr style={{ background: "#f0f4ff", fontWeight: "600", borderTop: "2px solid #dee2e6" }}>
                    <td colSpan={showEntryEdit ? 12 : 11} style={{ padding: "10px 12px" }}>
                      <div className="d-flex flex-wrap gap-4">
                        <span>
                          Opening Balance:{" "}
                          <span style={{ color: "#198754" }}>
                            ₹{Number(summary.opening_balance || 0).toFixed(2)}
                          </span>
                        </span>
                              <span>
                          Total Debited:{" "}
                          <span style={{ color: "#dc3545" }}>
                            -₹{Number(summary.total_debited_amount || 0).toFixed(2)}
                          </span>
                        </span>
                           <span>
                          Total Credited:{" "}
                          <span style={{ color: "#198754" }}>
                            +₹{Number(summary.total_credited_amount || 0).toFixed(2)}
                          </span>
                        </span>
                  
                        <span>
                          Closing Balance:{" "}
                          <span style={{ color: "#198754" }}>
                            ₹{Number(summary.closing_balance || 0).toFixed(2)}
                          </span>
                        </span>
                     
                        {/* <span>
                          Net Amount:{" "}
                          <span style={{ color: Number(summary.net_amount || 0) >= 0 ? "#198754" : "#dc3545" }}>
                            ₹{Number(summary.net_amount || 0).toFixed(2)}
                          </span>
                        </span>
                        <span>
                          Fund Transferred:{" "}
                          <span style={{ color: "#0d6efd" }}>
                            ₹{Number(summary.total_fund_transferred || 0).toFixed(2)}
                          </span>
                        </span> */}
                      </div>
                    </td>
                  </tr>
                </>
              ) : (
                <td colSpan={7}>
                  <img
                    className="p-3"
                    alt="no-result"
                    width="250"
                    src={`${process.env.REACT_APP_API_URL}/assets/images/no-results.png`}
                  />
                </td>
              )}
            </tbody>
            <tfoot>



              <tr>

                <td colSpan={10}>
                  <ReactPagination
                    pageSize={pageSize}
                    prevClassName={
                      pageNo === 1
                        ? "danger-combo-disable pe-none"
                        : "red-combo"
                    }
                    nextClassName={
                      pageSize == pageDetail?.total
                        ? transaction.length - 1 < pageSize
                          ? "danger-combo-disable pe-none"
                          : "success-combo"
                        : transaction.length < pageSize
                          ? "danger-combo-disable pe-none"
                          : "success-combo"
                    }
                    title={`Showing ${pageDetail?.pageStartResult || 0} to ${pageDetail?.pageEndResult || 0
                      } of ${pageDetail?.total || 0}`}
                    handlePageSizeChange={handlePageSizeChange}
                    prevonClick={() => setPageNo(pageNo - 1)}
                    nextonClick={() => setPageNo(pageNo + 1)}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </div>

      </Col>

      {/* Edit one statement entry's Narration / Transaction ID */}
      <Modal show={!!entryEdit} onHide={() => !entrySaving && setEntryEdit(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title as="h6">{isuser ? t("Edit Narration / Transaction ID") : t("Edit Remark / Transaction ID")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>{isuser ? t("Narration") : t("Remark")} *</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              maxLength={255}
              value={entryEdit?.description || ""}
              onChange={(e) => setEntryEdit({ ...entryEdit, description: e.target.value })}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>{t("Transaction ID")}</Form.Label>
            <Form.Control
              maxLength={100}
              value={entryEdit?.transaction_id || ""}
              onChange={(e) => setEntryEdit({ ...entryEdit, transaction_id: e.target.value })}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEntryEdit(null)} disabled={entrySaving}>
            {t("Cancel")}
          </Button>
          <Button variant="success" onClick={saveEntryEdit} disabled={entrySaving}>
            {entrySaving ? <Spinner animation="border" size="sm" /> : t("Save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Row>
  );
};
